export default __webpack_public_path__ + "assets/7659643fe7759a6374a272f6036f2322.png";